enum CustomerSupplierCategory {
  GENERAL_CONTRACTORS = 1, // ゼネコン
  HOUSE_MANUFACTURERS = 2, // ハウスメーカー
  TRADING_COMPANIES = 3, // 商社販売店
  READY_MIX_CONCRETE_PLANTS = 4, // 生コンプラント
  OTHERS = 5, // その他
}

enum BusinessPartnerClassification {
  CUSTOMER = 1, // 得意先
  SUPPLIER = 2, // 仕入先
  CONSTRUCTION_COMPANY = 3, // 建設会社
  WITNESS_COMPANY = 4, // 見積会社
}

enum StatusFile {
  LOADING = 1,
  DONE = 2,
  FAILED = 3,
}

enum snackbarType {
  ERROR = 'error',
  SUCCESS = 'success',
}

enum snackbarVertical {
  TOP = 'top',
  BOTTOM = 'bottom',
}

enum snackbarHorizontal {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
}

enum FunctionName {
  SCHEDULE_MANAGEMENT = 'plans',
  STAFF_MANAGEMENT = 'members',
  PROPERTY_MANAGEMENT = 'properties',
  COMPANY_MANAGEMENT = 'companies',
  ALL = 'all',
}

enum PermissionAction {
  MANAGE = 'manage',
  READ = 'read',
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
  MANAGE_PRICE = 'manage_price',
}

enum RoleKey {
  SALE = 'sale',
  DELIVERY = 'delivery',
  OUTSOURCING_DELIVERY = 'outsourcing_delivery',
  DELIVERY_AND_OUTSOURCING_DELIVERY = 'delivery_and_outsourcing_delivery',
}

enum ELinkCement {
  TARGET = 1,
  NOT_TARGET = 2,
}

export {
  CustomerSupplierCategory,
  BusinessPartnerClassification,
  StatusFile,
  snackbarType,
  snackbarVertical,
  snackbarHorizontal,
  FunctionName,
  PermissionAction,
  RoleKey,
  ELinkCement,
};
